/**
 * 处理人员实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-08
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    message,
    InputNumber,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const { TextArea } = Input;
const { Text } = Typography;

const MODULENAME_URL = CNF.navItems[2].submenu[2].url;

const Entity = ({ refresh, open, setOpen, record, }) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [weight, setWeight] = useState(1);
    const [description, setDescription] = useState('');

    const cancel = () => {
        setOpen(false);
        setWeight(1);
        setDescription('');

    };

    useEffect(() => {
        // 初始化
        setWeight(record.weight);
        setDescription(record.description);
    }, [record]);


    const ok = () => {
        //  参数校验
        if (!description) {
            messageApi.error('修改说明不能为空！', CNF.messageDuration);
            return;
        }
        setLoading(true);
        $.ajax
            ({
                url: `${CNF.api}${MODULENAME_URL.slice(1)}/${record.key}`,
                headers: AddRequestHeaders(),
                type: 'PUT',
                dataType: 'JSON',
                data: JSON.stringify({
                    weight: weight,
                    description: description,
                }),
            }).done((data) => {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                    setTimeout(function () {
                        cancel();
                        refresh();
                    }, CNF.messageDuration * 1000);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }).fail((err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            }).always(() => setTimeout(function () {
                setLoading(false);
            }, CNF.messageDuration * 1000))
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={record ? record.do_user + '-' + record.number : ''}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ loading }}
            >

                <Flex vertical gap='small'>
                    <Flex vertical>
                        <Text>绩效权重<Text type='danger'>*</Text></Text>
                        <InputNumber
                            style={{ width: '100%' }}
                            min={1}
                            max={10}
                            step={0.1}
                            onChange={(value) => setWeight(value)}
                            value={weight}
                            disabled={loading}
                        />
                    </Flex>
                    <Flex vertical>
                        <Text>修改说明<Text type='danger'>*</Text></Text>
                        <TextArea
                            placeholder='请输入'
                            autoSize={{ minRows: 3, maxRows: 6 }}
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                            disabled={loading}
                        />
                    </Flex>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity